<template>
  <div class="container">
    <div class="productCenter">
      <header>发展历程</header>
      <footer>Product&nbsp;Center</footer>
    </div>
    <div class="div">
      <div class="red">
        <span class="big">帮助</span> <span>客 户 把 猪 养 好</span>
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div class="box">
          <header>DEVELOPMENT</header>
          <div>HISTORY</div>
          <div class="name">加农正和历程</div>
          <div class="ad" @click="year < max ? year++ : false">
            <div :class="year == max ? 'add' : 'add1'"></div>
          </div>
          <div class="top">
            <a :href="'#' + Number(year)">{{ year }}</a>
          </div>
          <div class="bottom">
            <a :href="'#' + Number(year - 1)">{{ year - 1 }}</a>
          </div>
          <div class="re" @click="year - 1 > min ? year-- : false">
            <div :class="year - 1 == min ? 'reduce' : 'reduce1'"></div>
          </div>
        </div>
      </div>
      <div class="right">
        <div id="time-line">
          <div class="item" v-for="item in activities" :key="item.id">
            <div class="before"><div class="circle"></div></div>
            <div class="item-index">
              <span class="big" :id="item.name">{{ item.name }}</span>
              <span>年</span>
            </div>
            <div class="item-content">
              <ul>
                <li v-for="item1 in item.list" :key="item1.id" v-html="delHtmlTag(item1.name)" >
                  {{ item1.name }}
                </li>
              </ul>
            </div>
            <div class="after"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      activities: [],
      year: 0,
      max: 0,
      min: 0,
    };
  },
  methods: {

    delHtmlTag(str) {
      console.log(str)
      // if (str != null || str == undefined  ) {
      //   console.log(str.replace(/<[^>]+>/g, ""))
      //   return str.replace(/<[^>]+>/g, "");
      if (str != null || str == undefined  ) {
        let estr = str
            // .replace(/<[^>]+>/g, "")
                .replace(/&lt;/g,"<")
                .replace(/&gt;/g,">")
                .replace(/&amp;/g, "")
                .replace(/&nbsp;/g,"")
                .replace(/nbsp;/g,"")
                .replace(/&quot;/g, '"')
        ;
        console.log(estr)
        return estr

      }else {
        console.log(222);
      }

    },
  },
  async created() {
    this.activities = (
      await axios({
        method: "get",
        // url: "/xm/index.php/index/index/getHistory",
        url: "https://www.jianongzhenghe.com/index.php/index/index/getHistory",

        params: {},
      })
    ).data.data.reverse();
    this.year = this.activities[0].name;
    this.max = this.activities[0].name;
    this.min = this.activities[this.activities.length - 1].name;
  },
};
</script>

<style lang="less" scoped>

 /deep/ img{
   width:25vw!important;
  }

/deep/.productCenter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  header {
    text-align: center;
    height: 2.0833vw;
    font-size: 2.2917vw;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    color: #1EA364;
    margin-top: 4.1146vw;
    letter-spacing:0.15vw;
  }
  footer {
    text-align: center;
    height: 1.0417vw;
    font-size: 1.3542vw;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #646464;
    margin-top: 1.0417vw;
    margin-bottom: 6vw;
  }
}

// 时间线
#time-line {
  .before {
    width: 1.5625vw;
    height: 1.5625vw;
    border-radius: 100%;
    border: 0.1563vw solid #d3d3d3;
    position: absolute;
    left: -1.5625vw;
    top: -0.5208vw;
    .circle {
      width: 0.7813vw;
      height: 0.7813vw;
      border-radius: 100%;
      background-color: #d3d3d3;
      position: absolute;
      left: 0.4167vw;
      top: 0.3646vw;
    }
  }
  .after {
    width: 0.1563vw;
    height: calc(100% + 2.7604vw);
    background-color: #dadada;
    position: absolute;
    top: calc(1.8229vw + -0.5208vw);
    left: -0.6771vw;
  }
}
.item {
  padding-left: 0.5625vw;
  width: calc(100% - 1.5625vw);
  height: auto;
  position: relative;
  margin-bottom: 4.5208vw;
  &:last-child .after {
    display: none;
  }
}

.item-index {
  line-height: 0.625vw;
  font-size: 0.625vw;
  position: relative;
  left: 0.8667vw;
  color: #656565;
  .big {
    color: #1EA364;
    font-size: 1.5625vw;
    font-weight: 700;
    margin-right: 0.5208vw;
  }
}
.item-content {
  left: 2.1667vw;
  width: 100%;
  height: auto; /*由内容决定*/
  position: relative;
  ul {
    margin-top: 1.5625vw;
    width: 90%;
    li {
      line-height: 1.5417vw;
      position: relative;
      letter-spacing: 0.0817vw;
      width: 100%;
      margin-bottom: 1.5625vw;
      &::before {
        top: 0.3646vw;
        left: -1.0417vw;
        position: absolute;
        margin-right: 0.7813vw;
        content: "";
        width: 0.5208vw;
        height: 0.5208vw;
        display: inline-block;
        border-radius: 100%;
        background-color: red;
      }
    }
  }
}

.container {
  position: relative;
  margin-bottom: 10vw;
  .div {
    width: 100%;
    height: 3.9063vw;
    margin-top: 1.0417vw;
    margin-bottom: 4.1667vw;
    .red {
      padding-left: 0.1667vw;
      line-height: 3.9063vw;
      right: 0;
      width: 56.25vw;
      height: 3.9063vw;
      position: absolute;
      background-color: #1EA364;
      color: #ffffff;
      .big {
        margin-left: 3.125vw;
        font-size: 1.9271vw;
        font-weight: 500;
      }
    }
  }
  .content {
    display: flex;
    position: relative;
    .left {
      flex: 40;
      .box {
        /*position: absolute;*/
        position: sticky;
        top: 0;
        box-sizing: border-box;
        padding: 0 4.0417vw;

        overflow: hidden;
        left: 9.8958vw;
        width: 20.8854vw;
        height: 29.8958vw;
        border-radius: 1.0417vw;
        background-image: url("./images/bg.png");
        background-size: 100%;
        font-size: 1.5625vw;
        color: #e0a6a8;

        header {
          margin-top: 2.3438vw;
          font-weight: 200;
          text-align: right;
          margin-bottom: 0.5208vw;
        }
        div {
          text-align: right;
          font-weight: 200;
          margin-bottom: 1vw;
        }
        .name {
          color: #ffffff;
          font-weight: 400;
          margin-bottom: 3.5208vw;
        }
        .ad {
          position: relative;
          height: 1.5625vw;
          .add {
            position: absolute;
            right: 0.3646vw;
            cursor: pointer;
            width: 2.3958vw;
            height: 1.3542vw;
            background-image: url("./images/xiayibu.png");
            background-size: 100%;
          }
          .add1 {
            position: absolute;
            right: 0.3646vw;
            cursor: pointer;
            background-image: url("./images/xiayibu1.png");
            width: 2.3958vw;
            height: 1.3542vw;
            transform: rotate(180deg);
            background-size: 100%;
          }
        }
        .re {
          position: relative;
          height: 1.5625vw;
          .reduce {
            position: absolute;
            right: 7px;
            cursor: pointer;
            width: 2.3958vw;
            transform: rotate(180deg);
            height: 1.3542vw;
            background-image: url("./images/xiayibu.png");
            background-size: 100%;
          }
          .reduce1 {
            position: absolute;
            right: 0.3646vw;
            cursor: pointer;
            width: 2.3958vw;
            height: 1.3542vw;
            background-image: url("./images/xiayibu1.png");
            background-size: 100%;
          }
        }
        .top {
          a {
            font-size: 1.5625vw;
            color: #fdf6f7;
            font-weight: 400;
          }
        }
        .bottom {
          a {
            font-size: 1.5625vw;
            font-weight: 400;
            color: #fdf6f7;
          }
        }
      }
    }
    .right {
      flex: 64;
      margin-left: 15vw;
    }
  }
}
</style>
